import { UiSuspensefulOutlet } from '@experiences/ui-common';
import type { PropsWithChildren } from 'react';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { routePaths } from '../../../common/constants/routePaths';
import { useOrganizationName } from '../../../common/hooks/useOrganizationName';
import BreadcrumbProvider from '../../../common/providers/BreadcrumbProvider';
import { useTenantIdContext } from '../../../common/providers/TenantIdProvider';
import type { UiRouteObject } from '../../../container/routeConfigs/UiRouteObject';

const TenantA4EComponent = React.lazy(() => import('./TenantA4EComponent'));

const TenantA4EProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { formatMessage: translate } = useIntl();

    const organizationName = useOrganizationName();
    const { tenantName } = useTenantIdContext();

    const breadCrumbLinks = useMemo(() => [
        {
            index: 0,
            link: routePaths.admin,
            name: organizationName,
        },
        {
            index: 1,
            link: routePaths.adminTenantHome,
            name: tenantName ?? translate({ id: 'CLIENT_TENANT' }),
        },
        {
            index: 2,
            link: routePaths.adminTenantA4E,
            name: translate({ id: 'CLIENT_A4E' }),
        },
    ], [ organizationName, tenantName, translate ]);
    return <BreadcrumbProvider breadcrumbs={breadCrumbLinks}>
        {children}
    </BreadcrumbProvider>;
};

export const TenantA4ERoutes: UiRouteObject = {
    path: routePaths.adminTenant,
    element: <TenantA4EProvider>
        <UiSuspensefulOutlet />
    </TenantA4EProvider>,
    children: [
        {
            path: routePaths.adminTenantA4E,
            element: <TenantA4EComponent />,
        },
    ],
};
